import 'angular';

import '../../app-lite/xero/xero.module.ajs';

import { ResolveXeroContactsCtrl } from './xero.resolve-contacts';
import { XeroStates }              from './xero.states.ajs';
import { XeroSettingsCtrl }        from './xero.settings';

angular.module('workshop.xero', [
  'app-lite.xero'
])
.config(XeroStates)
.controller('ResolveXeroContactsCtrl', ResolveXeroContactsCtrl)
.controller('XeroSettingsCtrl', XeroSettingsCtrl);